import React from 'react';

export function LightBulbIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='34' height='52' viewBox='0 0 34 52' fill='none' {...props}>
            <path
                d='M23.8511 43.666H9.76813C8.85688 43.666 8.11816 44.4047 8.11816 45.316V45.5493C8.11816 46.4606 8.85688 47.1993 9.76813 47.1993H23.8511C24.7624 47.1993 25.5011 46.4606 25.5011 45.5493V45.316C25.5011 44.4047 24.7624 43.666 23.8511 43.666Z'
                stroke='#25477B'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M23.8511 40.1328H9.76813C8.85688 40.1328 8.11816 40.8715 8.11816 41.7828V42.0161C8.11816 42.9274 8.85688 43.6661 9.76813 43.6661H23.8511C24.7624 43.6661 25.5011 42.9274 25.5011 42.0161V41.7828C25.5011 40.8715 24.7624 40.1328 23.8511 40.1328Z'
                stroke='#25477B'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M20.8342 50.9991H12.7844C12.2177 50.9991 11.6844 50.6491 11.4677 50.1325L10.2178 47.1992H23.4008L22.1508 50.1325C21.9342 50.6658 21.4008 50.9991 20.8342 50.9991Z'
                stroke='#25477B'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M16.8014 4.81641C10.1849 4.81641 4.81836 10.1829 4.81836 16.7995'
                stroke='#0078D3'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M16.8017 1C8.11854 1 1.15204 7.84984 1.00205 16.533C0.935381 20.7329 2.50201 24.5494 5.10195 27.416C7.46856 30.016 8.86853 33.3326 8.96852 36.8325C9.20185 36.6992 9.46851 36.5992 9.75184 36.5992H23.8348C24.1182 36.5992 24.3848 36.6992 24.6182 36.8325C24.7182 33.3992 25.9848 30.0993 28.3347 27.5827C30.968 24.7661 32.5846 20.9662 32.5846 16.7996C32.6013 8.0665 25.5348 1 16.8017 1Z'
                stroke='#0078D3'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M23.8511 36.5977H9.76813C8.85688 36.5977 8.11816 37.3364 8.11816 38.2476V38.4809C8.11816 39.3922 8.85688 40.1309 9.76813 40.1309H23.8511C24.7624 40.1309 25.5011 39.3922 25.5011 38.4809V38.2476C25.5011 37.3364 24.7624 36.5977 23.8511 36.5977Z'
                stroke='#25477B'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
}
